enum BitcoinNetwork {
  Mainnet = 'mainnet',
  Testnet = 'testnet',
  Regtest = 'regtest'
}

export { BitcoinNetwork };
